export const TAKTILE_STAFF_EMAIL_DOMAIN = "@taktile.com";

/**
 * Staff identity by email domain, mirroring the backend gates on privileged
 * grants and role downscoping (taktile-api api/security/staff.py).
 */
export const isTaktileStaffEmail = (
  email: string | null | undefined,
): boolean => !!email?.toLowerCase().endsWith(TAKTILE_STAFF_EMAIL_DOMAIN);
